export default "__VITE_ASSET__MtC2OgO1__"